import {moneyFormatter, moneyFormatterCents} from "../../lib/formatters";
import {Input} from "../ui/input";

/**
 * Parses a USD-formatted string back into a number.
 * Intl.NumberFormat doesn't provide a parse API, so strip symbols manually.
 *
 * @param {string} str e.g. "$1,234" or "$1,234.56"
 * @returns {number}
 */
export function USDonChange(value: string) {
    if (value === "") {
        return "";
    }
    // const cents = Math.round((amount - Math.trunc(amount)) * 100);
    // const rawValue = value.replace(/[^0-9.]/g, '');
    const rawValue = value.replace(/[$,]/g, "");
    const parsedValue = parseFloat(rawValue);

    if (!isNaN(parsedValue)) {
        return parsedValue.toString();
    } else {
        return ""
    }
}

export function NumClean(value: string){
    return  value.replace(/[^0-9.,]/g, "");
}

export function USDonChange2(value: string) {
    if (value === "") {
        return "";
    }
    // const cents = Math.round((amount - Math.trunc(amount)) * 100);
    // const rawValue = value.replace(/[^0-9.]/g, '');
    const rawValue = value.replace(/[$,]/g, "");

    // console.log('v1', rawValue);

    if (/^\d+\.$/.test(rawValue)) {

        //console.log('v2', rawValue);

        return rawValue;
    }

    const parsedValue = parseFloat(rawValue);

    if (!isNaN(parsedValue)) {
        return parsedValue.toString();
    } else {
        return ""
    }
}

export function USDtoValueCell(amount: any) {
    // console.log(amount);
    if (amount) {
        // Detect whether there's any non-zero cents
        const cents = Math.round((amount - Math.trunc(amount)) * 100);
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: cents ? 2 : 0,
            maximumFractionDigits: 2,
        });

        return formatter.format(amount);
    }
    return "";
}


export function USDtoValue(value: any) {
    if (value) {
        //console.log(value);
        return moneyFormatterCents.format(Number(value))
    }
    return "";
}

